import { render, staticRenderFns } from "./BrandSlider.vue?vue&type=template&id=4fe54b02&scoped=true&"
import script from "./BrandSlider.vue?vue&type=script&lang=js&"
export * from "./BrandSlider.vue?vue&type=script&lang=js&"
import style0 from "./BrandSlider.vue?vue&type=style&index=0&id=4fe54b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe54b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe54b02')) {
      api.createRecord('4fe54b02', component.options)
    } else {
      api.reload('4fe54b02', component.options)
    }
    module.hot.accept("./BrandSlider.vue?vue&type=template&id=4fe54b02&scoped=true&", function () {
      api.rerender('4fe54b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/BrandSlider.vue"
export default component.exports